export interface JsonContractUt {
  id: string;
  name: string;
}

export class ContractUt {
  id: string;
  name: string;

  constructor(jsonContractUt: JsonContractUt = null) {
    if (jsonContractUt) {
      // XXXX use when new contract creation
      if (jsonContractUt.id === 'XXXX') {
        this.id = null;
        this.name = null;
      } else {
        this.id = jsonContractUt.id;
        this.name = jsonContractUt.name;
      }
    }
  }
}
